export default {
    intro: `씨앗글자는 단어를 이루는 가장 작은 요소예요.<br />
            씨앗글자로 만든 단어와 글자 사이의 관계를 함께 살펴보세요. `,
    options: {
        textbook: '교과서에 나오는 단어',
    },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `${round === 1 ? '첫 번째' : '두 번째'} 글자`;
        },
        title: {
            word: '글자',
            example1: '예시 단어1',
            example2: '예시 단어2',
            check: '배운 단어 확인',
            question: '단어 문제',
            meaning: '의미 관계 확인',
            meaningQuestion: '의미 관계 문제',
        },
    },
    indicator: {
        word: '씨앗글자의 모양, 소리, 뜻을 배워요.',
        example1: '씨앗글자가 들어간 두 단어를 배워요.',
        example2: '씨앗글자가 단어에서 어떻게 쓰이는지 배워요.',
        question: '두 단어 중 "{ reading }" 자가 사용된 단어는 무엇일까요?',
        meaning: '씨앗글자가 단어에서 어떻게 쓰이는지 배워요.',
        meaningQuestion: '두 씨앗글자의 의미 관계는 무엇일까요?',
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher
                ? '학생들이 직접 큐브를 돌리며 익히는 구간이에요.'
                : '직접 큐브를 돌리며 글자를 익혀 보세요.';
        },
    },
    result: {
        correct: '정답',
        incorrect: '오답',
    },
    buttons: {
        next: '다음으로',
    },
};
